import axios from "axios";
import { setAlert } from "./alert";

import {
  REGISTER_FAIL,
  USER_LOADED,
  AUTH_ERROR,
  LOGIN_FAIL,
  LOGOUT,
} from "./types";
import { removeInvite } from "./invite_ids";
import { trackPlausibleEvent } from "../utils/plausible";

// Register User
export const register = ({ first_name, last_name, email, password, workspace_id, invite_id }) => async (dispatch) => {
  const config = {
    headers: {
      "Content-Type": "application/json",
    },
  };
  const body = JSON.stringify({ first_name, last_name, email, password, workspace_id, invite_id });
  try {
    const res = await axios.post("/api/register", body, { ...config, withCredentials: true });
    if(res.status === 200) {
      if(res.data.msg === "success") {
        return 1;
      }
      else {
        dispatch(removeInvite());
        dispatch(loadUser(res));
        trackPlausibleEvent("Signup Completed", { method: "password" });
        if (res.data.workspace_title) {
          dispatch(setAlert(`You've been added to "${res.data.workspace_title}"`, "success", 6000));
        }
      }
    }

  } catch (err) {
    const errors = err.response?.data?.errors;
    trackPlausibleEvent("Signup Failed", {
      method: "password",
      reason: errors?.[0]?.msg || err.response?.data?.error || "unknown",
    });
    if (errors) {
      errors.forEach((error) => dispatch(setAlert(error.msg, "danger")));
    }
    dispatch({ type: REGISTER_FAIL });
    return { error: errors?.[0]?.msg || 'Registration failed' };
  }
};

// login user
export const login = ({email,password, workspace_id, invite_id}) => async (dispatch) => {
  const config = {
    headers: {
      "Content-Type": "application/json",
    },
  };
  const body = JSON.stringify({ email, password, workspace_id, invite_id});
  try {
    //console.log(body)
    const res = await axios.post("/api/auth", body, { ...config, withCredentials: true });
    if(res.status === 200) {
      dispatch(removeInvite())
      trackPlausibleEvent("Login Completed", { method: "password" });
      /*dispatch({
        type:LOGIN_SUCCESS,
        payload: res.data 
      });*/
      dispatch(loadUser(res));
    }
    
  }
  catch(err) {
    const errors = err.response?.data?.errors;
    trackPlausibleEvent("Login Failed", {
      method: "password",
      reason: errors?.[0]?.msg || err.response?.data?.error || "unknown",
    });
    if(errors) {
      errors.forEach((error) => dispatch(setAlert(error.msg, "danger")));
    }
    dispatch({
      type:LOGIN_FAIL
    });
  }
};


// Load User
export const loadUser = (res) => async (dispatch) => {
  try {
    dispatch({
      type: USER_LOADED,
      payload: res.data,
    });
  } catch (err) {
    dispatch({
      type: AUTH_ERROR,
    });
  }
};

export const logoutUser = () => async(dispatch) => {
    try {
      await axios.post("/api/auth/logout", {}, { withCredentials: true });
    } catch (err) {
      // Clear locally even if the cookie-clearing request fails.
    }
    dispatch({type:LOGOUT});
}
